export const CATEGORY_WEIGHTS = {
  mindset: 0.2,
  sleep: 0.2,
  exercise: 0.2,
  nutrition: 0.2,
  biohacking: 0.2
};

export const MISSION_TARGET_YEARS = 20;  // Target years to add
export const MISSION_DURATION_YEARS = 5; // Duration of initial mission